import angular = require("angular");
import TPL = require("templates");

export class FieldDirective {

  scope;
  template;

  constructor() {
    this.template = TPL.commonDirectives.field;
    this.scope = {
      name: "=name",
      value: "=value"
    }
  }

  static factory() {
    var tmp = () => new FieldDirective();
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/field.ts
 **/